import { useContext } from 'react';
import ApplicationContext from '../ApplicationContext';
import { SystemSettings } from '../ifmsTypes';

export interface ExtendedSystemSettings extends SystemSettings {
  userId: string|null,
};

export default function useSystemSettings():ExtendedSystemSettings {
  const appContext = useContext(ApplicationContext);
  
  const fromSettings = appContext?.systemSettings ? appContext.systemSettings : {};
  const userId = appContext && appContext.user ? appContext.user.id : null;

  return {
    ...fromSettings,
    userId,
  };
}
